import dynamic from "next/dynamic";

export const DynamicContent007 = dynamic(() => import("./Content007"), {
  suspense: true,
});
